import axios from 'axios'
import { Toast } from 'vant'
import { qiniuUploadUrl } from '@/utils/constant'
// 统一配置
const service = axios.create({
  baseURL: '',
  responseType: 'json',
  timeout: 300000
})
// count 不为0有遮罩
let count = 0
service.interceptors.request.use((res: any) => {
  count++
  Toast.loading({
    duration: 0,
    message: qiniuUploadUrl === res.url ? '上传中...' : '加载中...',
    forbidClick: false
  })
  const userId = window.localStorage.getItem('userId') || ''
  const companyId = window.localStorage.getItem('companyId') || ''
  if (res.type && res.type === 'outForm') {
    res.headers.logincompanyid = window.sessionStorage.getItem('logincompanyid') || ''
  } else {
    res.headers.loginUserId = userId
    res.headers.loginCompanyId = companyId 
  }
  return res
})

// 拦截响应
service.interceptors.response.use(
  (response) => {
    count--
    if (count === 0) {
      Toast.clear()
    }
    const res = response.data
    if (res.success || res.key || res.openid) {
      if (res.message) {
        Toast.success({
          duration: 2000,
          message: res.message
        })
      }
      return response
    } else {
      if (res.code) {
        Toast.fail({
          duration: 2000,
          message: res.message || res.errmsg
        })
        return response
      } else {
        if (res.message) {
          Toast.fail({
            duration: 2000,
            message: res.message || res.errmsg
          })
        }
        return Promise.reject(res)
      }
    }
  },
  err => {
    count--
    if (count === 0) {
      Toast.clear()
    }
    Toast.fail({
      duration: 2000,
      message: err.message || err.errmsg
    })
    return Promise.reject(err)
  }
)

// 异常token过期 重定向到 login
export default (req: any) => {
  return service(req).then((res) => {
    return res.data
  })
}
